// Public, short-lived server data only. Never hydrate account, cart, inventory,
// payment or concierge state from the homepage bootstrap.
export function readHomepageBootstrap(pathname = typeof window === "undefined" ? "" : window.location.pathname) {
  if (typeof document === "undefined") return null;
  try {
    const data = JSON.parse(document.getElementById("ecotour-home-bootstrap")?.textContent || "null");
    const age = Date.now() - Number(data?.generatedAt);
    if (data?.version !== 1 || data.pathname !== pathname || data.locale !== "en"
      || !Number.isFinite(age) || age < -5000 || age > 60000) return null;
    return {
      ...data,
      promotions: {
        items: (data.promotions?.items || []).filter((item) => {
          const end = Date.parse(item?.schedule?.endDate || item?.schedule?.endAt || item?.endsAt || "") || Infinity;
          return end > Date.now();
        }),
      },
    };
  } catch {
    return null;
  }
}
